export const settings = {
    className: 'center',
    infinite: false,
    adaptiveHeight: true,
    swipeToSlide: true,
    initialSlide: 0,
    dots:true,
    arrows:false,
    speed: 500,
    responsive :[
        {
            breakpoint: 999999,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 917,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 611,
            settings: {
                dots: true,
                speed: 500,
                focusOnSelect: true,
                slidesToScroll: 2,
                slidesToShow: 1,
                centerMode: true,
                respondTo: 'window',
                className: 'mx-auto',
                variableWidth: true,
                centerPadding: '0',
                initialSlide: 1,
            }
        },
        {
            breakpoint: 305,
            settings: {
                dots: true,
                speed: 500,
                focusOnSelect: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                centerMode: true,
                respondTo: 'window',
                className: 'mx-auto',
                variableWidth: false,
                centerPadding: '0',
                initialSlide: 1,
            }
        },
    ]
};